import i18n from '@/shared/i18n';
import BaseModel from "@/core/components/input-widget/BaseModel";
import i18nHelper from "@/core/services/i18n.service";

export default class SaleExportModel extends BaseModel {
  include_field_with_html_tags = false;
  language_code = i18nHelper.getMasterLanguage().key;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    include_field_with_html_tags: 'required',
    language_code: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
    include_field_with_html_tags: i18n.t('Include Fields with HTML Tags'),
    language_code: i18n.t('Language'),
  };
}
